import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import useSelectedWorkPackageInspections from '../../rxdb/inspectionList/useSelectedWorkPackageInspections';
import { InspectionStatus } from '../../utilities/enums';
import { getStatusForInspection, groupBy } from '../../utilities/utilityFunctions';

interface Props {
  workpackageId: number;
}

const useStyles = makeStyles({
  text: { whiteSpace: 'pre', position: 'relative', top: 6, letterSpacing: 0.4 },
});

const InspectionCountStripe: React.FC<Props> = ({ workpackageId }) => {
  const classes = useStyles();
  const { inspectionsUnderWorkPackage } = useSelectedWorkPackageInspections(workpackageId);
  const inspectionsGrouppedByStatus = groupBy(
    inspectionsUnderWorkPackage,
    'assetInspectionStatusId',
  );

  const inspectionStatusPriority = [
    InspectionStatus.UPCOMING,
    InspectionStatus.ASSIGNED,
    InspectionStatus.IN_PROGRESS,
    InspectionStatus.FI_SIGN_PENDING,
    InspectionStatus.LI_PENDING_APPROVAL,
    InspectionStatus.LI_SIGN_PENDING,
    InspectionStatus.SC_PENDING_APPROVAL,
  ];

  const result = inspectionStatusPriority
    .map(key => {
      return { key, count: inspectionsGrouppedByStatus[key]?.length || 0 };
    })
    .filter(element => element.count > 0);

  const firstLine = result.filter((_, index) => index < 4);
  const secondLine = result.filter((_, index) => index > 3);

  return (
    <>
      {firstLine.length > 0 && (
        <Typography color="primary" variant="caption" className={classes.text}>
          {firstLine
            .map(element => {
              return `${getStatusForInspection(Number(element.key))} - (${element.count})`;
            })
            .join(', ')}
        </Typography>
      )}
      {secondLine.length > 0 && (
        <Typography color="primary" variant="caption" className={classes.text}>
          {secondLine
            .map(element => {
              return `${getStatusForInspection(Number(element.key))} - (${element.count})`;
            })
            .join(', ')}
        </Typography>
      )}
    </>
  );
};

export default InspectionCountStripe;
